export default {
  errorType: 1, //错误提示类型
  locale: 'zh-cn', //语言类型
  refreshTokenTimer: null,
  terminal_type: 2,
  is_allow_pay: false,
}



// WEBPACK FOOTER //
// ./src/config.js